import React, { useEffect, useMemo, useState } from "react";
import clsx from "clsx";

import { FiArrowRight } from "react-icons/fi";

import CategoryRow from "./CategoryRow";

import "../styles/MetricConfigurationCard.scss";

const MetricConfigurationCard = ({
  configurationData,
  onConfigurationSave,
  savingConfiguration,
}) => {
  const [weights, setWeights] = useState([]);
  const totalWeight = useMemo(
    () =>
      weights.reduce(
        (sum, item) =>
          item.is_active ? sum + (Number(item.weight_percent) || 0) : sum,
        0
      ),
    [weights]
  );

  useEffect(() => {
    setWeights([...configurationData.metrics] || []);
  }, [configurationData]);

  const handleToggle = (metrics) => {
    setWeights((prevWeights) =>
      prevWeights.map((item) =>
        item.metrics === metrics
          ? {
              ...item,
              is_active: !item.is_active,
            }
          : item
      )
    );
  };

  const handleWeightChange = (metrics, value) => {
    setWeights((prevWeights) =>
      prevWeights.map((item) =>
        item.metrics === metrics ? { ...item, weight_percent: value } : item
      )
    );
  };

  return (
    <div className="metric-configuration-card">
      <div className="metric-card-header-row">
        <div className="metric-card-header-cell">Category</div>
        <div className="metric-card-header-cell text-center">Selection</div>
        <div className="metric-card-header-cell text-center">Weight</div>
      </div>

      <div className="table-divider" />

      <div className="metric-card-list">
        {weights.map((item, index) => (
          <CategoryRow
            key={item.metrics}
            item={item}
            onToggle={handleToggle}
            onWeightChange={handleWeightChange}
            showDivider={index < weights.length - 1}
          />
        ))}

        <div className="table-divider" />

        <div className="total-row">
          <div className="total-row__label">Total</div>
          <div className="total-row__spacer" />
          <div className="total-row__value">
            <div className="total-row__value-text">
              <span>{totalWeight}</span>
              <span className="percent-symbol">%</span>
            </div>
          </div>
        </div>
      </div>

      <div
        className={clsx(
          "validation-message",
          totalWeight === 100 && "validation-message--hidden"
        )}
      >
        <span className="validation-message__icon" />
        <span>Total sum of weights has to be 100%</span>
      </div>

      <button
        type="button"
        disabled={totalWeight !== 100 || savingConfiguration}
        onClick={() =>
          onConfigurationSave(
            weights.map((item) => ({
              ...item,
              weight_percent: Number(item.weight_percent) || 0,
            }))
          )
        }
        className={clsx(
          "run-button",
          totalWeight === 100 ? "" : "run-button--disabled"
        )}
      >
        Save new parameter weights
        <FiArrowRight className="run-button__icon" />
      </button>
    </div>
  );
};

export const MetricSkeletonLoader = () => {
  return (
    <div className="metric-configuration-card metric-configuration-card--loading">
      <div className="skeleton-loader skeleton-loader--header" />
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} className="skeleton-loader skeleton-loader--row" />
      ))}
      <div className="skeleton-loader skeleton-loader--total" />
      <div className="skeleton-loader skeleton-loader--button" />
    </div>
  );
};

export default MetricConfigurationCard;
